import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconEdit, IconSend } from "@tabler/icons-react";
import BackButton from "../../../../components/View/BackButton";
import { notifications } from "@mantine/notifications";
import EmailAccountSelector from "../../../../components/Selectors/EmailAccountSelector";
import { editGmail, editOutlook, editSMTP } from "../../../../api/EmailAPI";

const SignatureLink = ({ current, closeMenu, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [sender, setSender] = useState(null);

  const handleClose = () => {
    close();
    closeMenu?.();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    let handler =
      sender?.account_type === "Gmail"
        ? editGmail
        : sender?.account_type === "Outlook"
        ? editOutlook
        : editSMTP;
    handler({ id: sender.id, data: { email_signatures_id: current.id } })
      .then((res) => {
        notifications.show({
          message: "La signature a été liée",
          color: "tertiary.8",
        });
        close();
        onFinish?.();
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Button
        onClick={open}
        leftSection={<IconSend size={18} />}
        color="primary"
        variant="subtle"
        justify="start"
      >
        Lier à un expéditeur
      </Button>

      {opened && (
        <Modal
          opened={opened}
          size={"lg"}
          onClose={handleClose}
          title={
            <>
              Lier à un expéditeur la signature:{" "}
              <b>
                {current?.name} #{current.id}
              </b>
            </>
          }
        >
          <Stack component={"form"} onSubmit={handleSubmit} gap={"xs"}>
            <Text c={"dimmed"}>Lier cette signature à un expéditeur</Text>

            <EmailAccountSelector
              value={sender?.id}
              onChange={setSender}
              required
              error={
                sender?.signature_id
                  ? "Cet expéditeur a déjà une signature liée"
                  : null
              }
              smtpOnly="semi"
              label={"Expéditeur"}
            />

            <Group justify="end" mt={"md"}>
              <BackButton onClick={handleClose} />

              <Button
                leftSection={<IconEdit size={18} />}
                loading={loading}
                color="primary"
                type="submit"
              >
                Modifier l'expéditeur
              </Button>
            </Group>
          </Stack>
        </Modal>
      )}
    </>
  );
};

export default SignatureLink;
